import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-29244f16"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-flex flex-column"
};
var _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row modal-floor-item"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "fs-6 fw-bold mb-2 d-lg-none d-md-block d-none"
  }, " Filtre ", -1);
});

var _hoisted_4 = {
  class: "d-flex flex-sm-row flex-lg-column flex-column filter-input",
  style: {
    "flex": "25%"
  }
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "fs-6 fw-bold mb-2 ms-2 d-none d-lg-block"
  }, " Filtre ", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Réinitialiser tous les filtres", -1);
});

var _hoisted_7 = {
  class: "d-flex flex-column color-floor floor-images"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "fs-6 fw-bold mb-2 ms-lg-2"
  }, " Sélectionner la couleur du sol ", -1);
});

var _hoisted_9 = {
  class: "overflow-auto modal-height"
};
var _hoisted_10 = {
  class: "ps-0 patterns"
};
var _hoisted_11 = {
  class: "floor-container"
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = ["onUpdate:modelValue", "value"];
var _hoisted_14 = ["onClick", "src", "alt"];
var _hoisted_15 = {
  class: "pattern_name"
};
var _hoisted_16 = {
  key: 0,
  class: "d-flex pattern"
};
var _hoisted_17 = {
  class: "d-flex flex-column",
  style: {
    "flex": "30%"
  }
};
var _hoisted_18 = {
  class: "d-flex flex-column"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "mt-sm-5 mt-10 mt-lg-0"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "fs-6 fw-bold mb-5"
  }, " Information Produit ")], -1);
});

var _hoisted_20 = {
  key: 0,
  class: "mb-2"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "fw-bold"
  }, " Référence :", -1);
});

var _hoisted_22 = {
  class: "d-flex"
};
var _hoisted_23 = ["src", "alt"];
var _hoisted_24 = {
  class: "d-flex justify-content-between me-sm-15 me-0 mt-sm-12 mt-6",
  style: {
    "flex": "70%"
  }
};
var _hoisted_25 = {
  class: "d-flex flex-column justify-content-between"
};
var _hoisted_26 = {
  class: "d-flex flex-column justify-content-between"
};
var _hoisted_27 = {
  class: "d-flex flex-column justify-content-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_button = _resolveComponent("el-button");

  var _component_Info = _resolveComponent("Info");

  var _component_ModalLayout = _resolveComponent("ModalLayout");

  return _openBlock(), _createBlock(_component_ModalLayout, {
    "close-button": false,
    "max-width": "1000px",
    title: "Choisir un sol"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FILTER_PROPRIETES, function (proprity) {
        return _openBlock(), _createBlock(_component_el_select, {
          key: proprity.key,
          modelValue: _ctx.filtersSelected[proprity.key],
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.filtersSelected[proprity.key] = $event;
          },
          class: "m-2 w-sm-250px w-100",
          placeholder: proprity.label
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions[proprity.key], function (filter) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: filter,
                label: filter,
                value: filter
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]);
      }), 128)), _createVNode(_component_el_button, {
        type: "primary",
        class: "m-2 w-sm-250px w-100",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.filtersSelected = {};
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredPatterns, function (pattern, index) {
        var _ctx$selectedPattern;

        return _openBlock(), _createElementBlock("li", {
          key: index,
          style: {
            "cursor": "pointer"
          },
          class: "m-2 list-unstyled"
        }, [_createElementVNode("div", _hoisted_11, [_ctx.DEBUG ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.checkedPatterns[pattern.image] = $event;
          },
          value: pattern.image,
          id: ""
        }, null, 8, _hoisted_13), [[_vModelCheckbox, _ctx.checkedPatterns[pattern.image]]])])) : _createCommentVNode("", true), _createElementVNode("img", {
          onClick: function onClick($event) {
            return _ctx.handleChangeFloor(pattern);
          },
          id: "img",
          class: _normalizeClass(["w-lg-150px w-sm-125px h-sm-70px w-75px h-50px floor-image", [pattern.id === ((_ctx$selectedPattern = _ctx.selectedPattern) === null || _ctx$selectedPattern === void 0 ? void 0 : _ctx$selectedPattern.id) && 'active-floor']]),
          src: _ctx.patternImage(pattern.image),
          loading: "lazy",
          alt: pattern.category
        }, null, 10, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString(pattern.id), 1)])]);
      }), 128))])])])]), _ctx.selectedPattern ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _ctx.selectedPattern.id ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createTextVNode(" " + _toDisplayString(_ctx.selectedPattern.id), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_createElementVNode("img", {
        class: "me-5 w-250px h-100px rounded pattern-image",
        id: "img",
        src: _ctx.patternImage(_ctx.selectedPattern.image),
        alt: _ctx.selectedPattern.category
      }, null, 8, _hoisted_23)])])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_Info, {
        condition: _ctx.selectedPattern.type != null,
        info: _ctx.selectedPattern.type,
        title: 'Gamme'
      }, null, 8, ["condition", "info"]), _createVNode(_component_Info, {
        condition: _ctx.selectedPattern.tone != null,
        info: _ctx.selectedPattern.tone,
        title: 'Ton'
      }, null, 8, ["condition", "info"])]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_Info, {
        condition: _ctx.selectedPattern.category != null,
        info: _ctx.selectedPattern.category,
        title: 'Catégorie'
      }, null, 8, ["condition", "info"]), _createVNode(_component_Info, {
        condition: _ctx.selectedPattern.color != null,
        info: _ctx.selectedPattern.color,
        title: 'Couleur'
      }, null, 8, ["condition", "info"])]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_Info, {
        condition: _ctx.selectedPattern.look != null,
        info: _ctx.selectedPattern.look,
        title: 'matériaux utilisés'
      }, null, 8, ["condition", "info"]), _createVNode(_component_Info, {
        condition: _ctx.selectedPattern.dimensions != null,
        info: _ctx.selectedPattern.dimensions,
        title: 'Dimension'
      }, null, 8, ["condition", "info"])])])])) : _createCommentVNode("", true)])];
    }),
    _: 1
  });
}